module.exports = __webpack_public_path__ + "img/recommendLogo2.e532d0f1.png";